const StudentDetails = () => {
    return (

        "t"
    )
}

export default StudentDetails;